export default __webpack_public_path__ + "static/media/contact-bg.61836452.jpg";